import moment from "moment";

export const getDateFormat = (date, format) => moment(date, moment.ISO_8601, true).isValid() ? moment(date).format(format ? format : "DD/MM/YYYY") : ""